import { v4 as uuidv4 } from 'uuid';

import nexioTransactionUrl from '../views/NexioPayment/transaction.html?url';
import nexioCardUrl from '../views/NexioPayment/saved_cards.html?url';
import nexioHistoryUrl from '../views/NexioPayment/transaction_history.html?url';

NexioPaymentsController.$inject = ['$scope', 'allevaApi', '$sce', 'noty', '$timeout'];
export default function NexioPaymentsController($scope, allevaApi, $sce, noty, $timeout) {

    const nexioApiUrl = $scope.NexioApiUrl;
    $scope.nexioTransactionUrl = nexioTransactionUrl;
    $scope.nexioCardUrl = nexioCardUrl;
    $scope.nexioHistoryUrl = nexioHistoryUrl;


    $scope.nexioModel={};

    // Payments menu view states
    $scope.isTransactionView = true;
    $scope.isSavedCardView = false;
    $scope.isTransactionHistoryView = false;

    // Payments menu constants
    $scope._runTransactionView = 1;
    $scope._savedCardView = 2;
    $scope._transactionHistoryView = 3;

    // Properties
    $scope.isSavedCardLoaded = false;
    $scope.isTransactionHistoryLoaded = false;
    $scope.isIframeLoaded = false;
    

    this.$onInit = function () {
        window.addEventListener('message', nexioListener);
    };

    this.$onDestroy = function () {
        // Cleanup listeners, etc
        window.removeEventListener('message', nexioListener);
    };

    $scope.initNexioPayments = function (leadId, facilityId) {
        $scope.nexioModel.LeadId = leadId;
        $scope.nexioModel.FacilityId = facilityId;
        $scope.nexioModel.cardBeingSaved = false;
        $scope.nexioModel.transactionProcessing = false;
        $scope.nexioModel.transactionsListSynced = false;
        $scope.nexioModel.paymentAmount = undefined;
        $scope.nexioModel.selectedCardId = '';
        $scope.formIsValid = false;
        $scope.nexioModel.transactionUniqueId = null;
        $scope.loadSavedCards();
    };

    // Payments menu change method
    $scope.changePaymentMenu = (view) => {
        $scope.isTransactionView = false;
        $scope.isSavedCardView = false;
        $scope.isTransactionHistoryView = false;
        $scope.cancelSaveCard();
        switch(view) {
            case $scope._runTransactionView:
                $scope.isSavedCardLoaded = false;
                $scope.loadSavedCards();
                $scope.isTransactionView = true;
                break;
            case $scope._savedCardView:
                $scope.isSavedCardLoaded = false;
                $scope.loadSavedCards();
                $scope.isSavedCardView = true;
                break;
            case $scope._transactionHistoryView:
                $scope.isTransactionHistoryLoaded = false;
                $scope.loadTransactionHistory();
                $scope.isTransactionHistoryView = true;
                break;
        }
    };

    // Saved Card Section
     // Properties for Saved Cards view
    $scope.isCardsView = true;
    $scope.savedCards = [];

    // Load saved cards from API
    const getCards = (userId) => allevaApi.Nexio.Card.get(userId).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    const addNewCard = (userId, cardData) => allevaApi.Nexio.Card.create(userId, cardData).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    const getNexioIframe = (userId, facilityId) => allevaApi.Nexio.Card.getIFrame(userId, facilityId).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));
    const deleteCardApi = (userId, cardId) => allevaApi.Nexio.Card.delete(userId, cardId).then((response) => Promise.resolve(response)).catch((error) => Promise.reject(error));

    $scope.loadSavedCards = () => {
        if($scope.savedCards.length > 0){
            $scope.isSavedCardLoaded = true;
            return;
        }
        $scope.isSavedCardLoaded = false;
        $scope.savedCards = [];
        const userId = $scope.currentUser.rehabUserId;
        getCards(userId).then((cards) => {
            $scope.savedCards = cards.results || [];
            $scope.isSavedCardLoaded = true;
        }).catch(() => {
            $scope.isSavedCardLoaded = true;
        });
    };

    $scope.addCard = () => {
        $scope.isCardsView = false;
        $scope.isIframeLoaded = false;
        
        // Reset iframe and ensure DOM is updated before loading
        $timeout(() => {
            const iframe = window.document.getElementById('savecardiframe');
            if (iframe) {
                iframe.onload = null;
                iframe.src = '';
                $scope.loadNexioIframe($scope.nexioModel.FacilityId);
            }
        }, 0);
    };

    // Get Nexio iframe for card entry
    $scope.loadNexioIframe = (facilityId) => {
        const userId = $scope.currentUser.rehabUserId;
        $scope.isIframeLoaded = false;
        getNexioIframe(userId, facilityId).then((iframeUrl) => {
            const iframe = window.document.getElementById('savecardiframe');
            if (iframe) {
                iframe.src = $sce.trustAsResourceUrl(iframeUrl);
                // Set up onload handler for iframe
                iframe.onload = () => {
                    $scope.$apply(() => {
                        $scope.isIframeLoaded = true;
                    });
                };
            }
        }).catch((_) => {
            const iframe = window.document.getElementById('savecardiframe');
            if (iframe) {
                iframe.src = '';
            }
            $scope.isIframeLoaded = true;
            $scope.isCardsView = true;
        });
    };

    $scope.submitSaveCardiFrame = () => {
        if ($scope.formIsValid) {
            $scope.nexioModel.transactionProcessing = true;
        }
        const iframe = window.document.getElementById('savecardiframe');
        if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage('posted', nexioApiUrl);
        }
        return false; // keeps the form from auto submitting
    };

    $scope.cancelSaveCard = () => {
        $scope.isCardsView = true;
        $scope.isIframeLoaded = false;
        const iframe = window.document.getElementById('savecardiframe');
        if (iframe) {
            iframe.onload = null;
            iframe.src = '';
        }
    };

    // Delete a card
    $scope.deleteCard = (cardId) => {
        const userId = $scope.currentUser.rehabUserId;
        $scope.isSavedCardLoaded = false;
        deleteCardApi(userId, cardId).then(() => {
            $scope.savedCards = $scope.savedCards.filter((card) => card.id !== cardId);
            new noty({
                text: '<h5>Success</h5> <p>Card deleted successfully</p>',
                type: 'success',
            }).show();
            $scope.isSavedCardLoaded = true;
        }).catch(() => {
            $scope.isSavedCardLoaded = true;
        });
    };

    $scope.runSavedCardTransaction = function () {
        // Validation checks
        if ($scope.nexioModel.transactionProcessing) {
            return;
        }

        if (!$scope.nexioModel.paymentAmount || $scope.nexioModel.paymentAmount <= 0) {
            new noty({
                text: '<h5>Warning</h5> <p>Please enter a valid amount</p>',
                type: 'warning',
            }).show();
            return;
        }

        if ($scope.savedCards.length === 0) {
            new noty({
                text: '<h5>Warning</h5> <p>Please save a card before running a transaction</p>',
                type: 'warning',
            }).show();
            return;
        }

        if (!$scope.nexioModel.selectedCardId || $scope.nexioModel.selectedCardId < 0) {
            new noty({
                text: '<h5>Warning</h5> <p>Please select a card</p>',
                type: 'warning',
            }).show();
            return;
        }

        $scope.nexioModel.transactionProcessing = true;

        // Generate unique ID if not present
        if (!$scope.nexioModel.transactionUniqueId) {
            $scope.nexioModel.transactionUniqueId = uuidv4();
        }

        const transactionData = {
            Amount: $scope.nexioModel.paymentAmount,
            UniqueId: $scope.nexioModel.transactionUniqueId,
        };

        const params = {};
        if ($scope.nexioModel.FacilityId) {
            params.facilityId = $scope.nexioModel.FacilityId;
        }
        params.clientId = $scope.nexioModel.LeadId;

        // Reset transaction form helper
        const resetTransactionForm = () => {
            $scope.nexioModel.paymentAmount = undefined;
            $scope.nexioModel.selectedCardId = '';
            $scope.nexioModel.transactionUniqueId = null;
            $scope.nexioModel.transactionProcessing = false;
            $scope.nexioModel.transactionsListSynced = false;
            $scope.nexioModel.showRunSavedCardAmount = false;
            $scope.nexioModel.showTransactionsPanel = false;
        };

        allevaApi.Nexio.Card.runTransaction($scope.currentUser.rehabUserId, $scope.nexioModel.selectedCardId, params, transactionData)
            .then(response => {
                if (response) {     
                    new noty({
                        text: '<h5>Success</h5> <p>Transaction Submitted</p>',
                        type: 'success',
                    }).show();                   
                }
                resetTransactionForm();
            })
            .catch((error) => {
                if(error.status !== 435) {
                    new noty({
                        text: '<h5>Error</h5> <p>' + error.data + '</p>',
                        type: 'error',
                    }).show();
                }
                resetTransactionForm();
            });
    };

    const nexioListener = (event) => {
        const eventData = event.data.data;
        const eventType = event.data.event;
        if (event.origin === nexioApiUrl) {
            if (eventType === 'loaded') {
                $scope.$apply(() => {
                    $scope.isIframeLoaded = true;
                });
            }
            if (eventType === 'cardSaved') {
                if ($scope.nexioModel.cardBeingSaved) {
                    return;
                }
                $scope.nexioModel.cardBeingSaved = true;
                $scope.nexioModel.transactionProcessing = false;
                let savedCard = {
                    CardToken: eventData.token.token,
                    LastFour: eventData.token.lastFour,
                    CardType: eventData.token.cardType,
                    CardHolderName: eventData.card.cardHolderName,
                    Expiration: eventData.card.expirationMonth + "/" + eventData.card.expirationYear,
                    LeadId: null,
                }
                addNewCard($scope.currentUser.rehabUserId, savedCard).then((newCard) => {
                    if(newCard){
                        $scope.savedCards.push(newCard);
                        $scope.nexioModel.cardBeingSaved = false;
                        new noty({
                            text: '<h5>Success</h5> <p>Card saved successfully</p>',
                            type: 'success',
                        }).show();
                        $scope.isCardsView = true;
                        const iframe = window.document.getElementById('savecardiframe');
                        if (iframe) {
                            iframe.src = '';
                        }
                    } else{
                        new noty({
                            text: '<h5>Error</h5> <p>Error saving Card</p>',
                            type: 'error',
                        }).show();
                    }
                }).catch((error) => {
                    if(error.status !== 435) {
                        new noty({
                            text: '<h5>Error</h5> <p>' + error.data + '</p>',
                            type: 'error',
                        }).show();
                    }
                });
            }
            if (eventType === 'error') {
                $scope.nexioModel.transactionProcessing = false;
                new noty({
                    text: 'Error',
                    type: 'error',
                }).show();
            }

            // Used to validate the form
            if (eventType === 'formValidations') {
                $scope.formIsValid = eventData.isFormValid;                   
            }
        }
    };

    // Properties for Transaction History view
    $scope.transactionHistory = [];

    // Load Nexio transaction history for the current client
    $scope.loadTransactionHistory = function() {
        $scope.isTransactionHistoryLoaded = false;
        $scope.transactionHistory = [];
        const leadId = $scope.nexioModel.LeadId;
        if (!leadId) {
            $scope.isTransactionHistoryLoaded = true;
            return;
        }
        
        const params = {};
        if ($scope.nexioModel.FacilityId) {
            params.facilityId = $scope.nexioModel.FacilityId;
        }
        params.portalUserId = $scope.currentUser.rehabUserId;

        allevaApi.Nexio.Transaction.get(leadId, params)
            .then(function(data) {
                $scope.transactionHistory = data && data.results ? data.results : [];
                $scope.isTransactionHistoryLoaded = true;
            })
            .catch(function() {
                $scope.transactionHistory = [];
                $scope.isTransactionHistoryLoaded = true;
                noty.error('Failed to load transaction history.');
            });
    };
}
